// extracted by mini-css-extract-plugin
export default {"priceListFactors":"PriceListFactors_priceListFactors__9F-l-"};